"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var skynet_store_languages_api_1 = require("@synisys/skynet-store-languages-api");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var immutable_1 = require("immutable");
function deserializeLanguage(dto) {
    return new skynet_store_languages_api_1.StoreLanguage(dto.id, skynet_store_utilities_1.deserializeMultilingualString(dto.alias), skynet_store_utilities_1.deserializeMultilingualString(dto.acronym), dto.isRtl ? idm_crosscutting_concepts_frontend_1.LanguageDirection.RTL : idm_crosscutting_concepts_frontend_1.LanguageDirection.LTR, dto.isDefault, dto.charset, dto.isInput);
}
function serializeLanguage(language) {
    return {
        id: language.getId(),
        acronym: skynet_store_utilities_1.serializeMultilingualString(language.getAcronym()),
        isRtl: language.getDirection() === idm_crosscutting_concepts_frontend_1.LanguageDirection.RTL,
        alias: skynet_store_utilities_1.serializeMultilingualString(language.getName()),
        abbreviation: '',
        charset: 'UTF-8',
        isDefault: false,
        isInput: false,
    };
}
function deserializeLanguages(value) {
    return immutable_1.List(value.map(deserializeLanguage));
}
exports.deserializeLanguages = deserializeLanguages;
//# sourceMappingURL=language.serializer.js.map